/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Documentation_QualityInputs */

const en_directory_agent_readiness_dimension_documentation_quality = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Documentation_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation quality`)
};

const zh_directory_agent_readiness_dimension_documentation_quality = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Documentation_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档质量`)
};

/**
* | output |
* | --- |
* | "Documentation quality" |
*
* @param {Directory_Agent_Readiness_Dimension_Documentation_QualityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_documentation_quality = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Documentation_QualityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Documentation_QualityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_documentation_quality(inputs)
	return zh_directory_agent_readiness_dimension_documentation_quality(inputs)
});
export { directory_agent_readiness_dimension_documentation_quality as "directory.agent_readiness.dimension.documentation_quality" }